import React from "react";
import { Link, useNavigate } from "react-router-dom";
//import "./CpntSubHeader.scss";
import { IBreadCrumbs } from "../models/interfaces/IBreadCrumbs";

interface ICpntSubHeaderParam {
  ReturnPath: string;
  ReturnTitle?: string;
  ReturnClass?: string;
  BreadCrumbs?: IBreadCrumbs[];
  goBack?: boolean;
}

function CpntSubHeader({
  ReturnPath,
  ReturnTitle,
  ReturnClass,
  BreadCrumbs,
  goBack,
}: ICpntSubHeaderParam): JSX.Element {
  const navigate = useNavigate();

  const handleReturn = () => {
    if (goBack) {
        navigate(-1);
    } else {
        navigate(ReturnPath);
    }
  };

  return (
    <div className="App-products-menu row">
      {(ReturnPath || goBack) && (
        <div className="col-auto">
          <div
            className={ReturnClass ? ReturnClass : "btn btn-darkgrey"}
            onClick={handleReturn}
          >
            <i className="bi bi-arrow-return-left" />
            &nbsp;
            {ReturnTitle ? ReturnTitle : "Retour"}
          </div>
        </div>
      )}
      {BreadCrumbs && (
        <div className="col-auto">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {BreadCrumbs.map((BreadCrumb,i) => {
                if (BreadCrumb) {
                  const _href = Object.values(BreadCrumb)[0].toLowerCase();
                  const _title = Object.keys(BreadCrumb)[0];

                  return (
                    <li key={"li_" + i} className="breadcrumb-item active">
                      <Link to={_href}>{_title}</Link>
                    </li>
                  );
                }
              })}
            </ol>
          </nav>
        </div>
      )}
    </div>
  );
}

export default CpntSubHeader;
